import { render, staticRenderFns } from "./spin.vue?vue&type=template&id=13d4da24&scoped=true&"
import script from "./spin.vue?vue&type=script&lang=js&"
export * from "./spin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d4da24",
  null
  
)

export default component.exports